import React from 'react';
import styles from './nocontent.module.css';

const NoContent = props => {
    return(
        <div className={styles.container}>{ props.text || "No content for selected language."}</div>
    );
}

export default NoContent;